export const GO_BACK_KEY = 'calculator.ui.go-back';

export const CLOSE_MODAL_KEY = 'calculator.ui.close-modal';

export const CATEGORY_SET = 'COMPO';

export const LAMINATE_PROJECT_CONFIGURATION_ID_COOKIE_NAME = 'calculators_userProjectConfigurationLaminat';

export const UOMS = {
  CAR: 'CAR',
  M2: 'M2',
  MTK: 'MTK',
};

export const LAMINATE_CONFIGURATION_WIDGET_AB_KEY = 'calculators_configuration_widget_laminat_ab';
